module.exports = __webpack_public_path__ + "static/media/wild_berries.2ff10ca5.png";